import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

interface InstructionsProps {
  onClose: () => void;
}

export const Instructions: React.FC<InstructionsProps> = ({ onClose }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/50 z-10">
      <div
        className={`max-w-md p-6 rounded-xl ${
          isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
        }`}
      >
        <h2 className="text-2xl font-bold mb-4">Sailing Simulator</h2>

        <div className="space-y-4 text-sm">
          <div>
            <h3 className="font-semibold mb-1">Controls</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>
                <kbd className="px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded">
                  Left Arrow
                </kbd>{' '}
                or{' '}
                <kbd className="px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded">
                  H
                </kbd>{' '}
                - Turn rudder left (port)
              </li>
              <li>
                <kbd className="px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded">
                  Right Arrow
                </kbd>{' '}
                or{' '}
                <kbd className="px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded">
                  L
                </kbd>{' '}
                - Turn rudder right (starboard)
              </li>
              <li>
                <kbd className="px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded">
                  P
                </kbd>{' '}
                or{' '}
                <kbd className="px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded">
                  Escape
                </kbd>{' '}
                - Pause
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-1">Sailing Physics</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>You cannot sail directly into the wind (no-go zone)</li>
              <li>Use tacking (zig-zag) to sail upwind</li>
              <li>Beam reach (90° to wind) is the fastest</li>
              <li>The boat needs speed to turn effectively</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-1">Wind Indicator</h3>
            <p>
              The compass in the top-right shows wind direction. The red zone
              indicates where you cannot sail.
            </p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-6 w-full py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors"
        >
          Start Sailing
        </button>
      </div>
    </div>
  );
};
